import { render, staticRenderFns } from "./SkillTree.vue?vue&type=template&id=11731abd&scoped=true"
import script from "./SkillTree.vue?vue&type=script&lang=js"
export * from "./SkillTree.vue?vue&type=script&lang=js"
import style0 from "./SkillTree.vue?vue&type=style&index=0&id=11731abd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11731abd",
  null
  
)

export default component.exports